<template>
  <v-dialog :value="value" persistent max-width="1000px">
    <v-card height="720px">
      <v-stepper height="720px" v-model="view">
        <v-stepper-header>
          <v-stepper-step step="1" :complete="false">
            Store Information
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="false">
            Store Information (cont.)
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" :complete="false">
            Technology
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4" :complete="false">
            Marketing/Advertising
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content v-for="(page, pageIndex) in groupFields" :key="pageIndex" :step="pageIndex" class="flex-grow-1">
            <v-col class="pa-6" align="center">
              <v-row v-if="view === 4" class="mx-5 mb-5">
              <v-card-title style="font-size: 18px; font-weight: bold;">
              This portion of the New Store form is intended to capture ONLY interests in Agency Services. Please select all that apply!
              </v-card-title>
              <v-divider></v-divider>
            </v-row>
              <v-row v-for="(group, groupIndex) in page" :key="groupIndex" >
                <StoreFormField
                  v-for="(field, fieldIndex) in group"
                  :key="fieldIndex"
                  :field="field"
                  :currentPage="parseInt(pageIndex)"
                  :params="params"
                  :paymentTypes="paymentTypes"
                  :checkId="checkId"
                  :scanOnlyId="scanOnlyId"
                  :scanAndBillbackId="scanAndBillbackId"
                  :activeStoreList="activeStoreIdList"
                  :errorMessage="field.value === 'store_number' ? errorMessage : ''"
                  @update="updateParams"
                  @updateErrorMessage="updateErrorMessage"
                />
              </v-row>
            </v-col>
          </v-stepper-content>
          <v-card-actions class="mx-4 mt-1 mb-2 justify-space-between">
            <v-btn v-if="view === 1" @click="close" color="error" x-large>Close</v-btn>
            <v-btn v-if="view > 1" @click="back" color="primary" x-large>Back</v-btn>
            <v-btn v-if="view < 4" @click="forward" color="primary" :disabled="!pageIsValid" x-large>Continue</v-btn>
            <v-btn v-if="view === 4" @click="createStore" color="success" :disabled="!pageIsValid" x-large>Submit</v-btn>
          </v-card-actions>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>
<script>
import kvApi from "@/axios/key-values-endpoint.js"
import StoreFormField from '@/components/create_store_field.vue'
import Party from '@/axios/party-endpoint.js'
import { displayAlert } from '@/mixins/alert'
import { userAccess } from '../../mixins/user-access'

export default {

  name: 'CreateStoreModal',
  props: [
    'value'
  ],
  mixins: [displayAlert, userAccess],
  components: { StoreFormField },
  data() {
    return {
      view: 1,
      params: {
          store_number: null,
          name: null,
          start_date: null,
          group_manager_id: null,
          division_id: null,
          store_format_id: null,
          ad_group_id: null,
          weekly_sales: null,
          square_footage: null,
          store_address: {
            street: null,
            city: null,
            state: null,
            zip_code: null,
            phone_number: "",
          },
          key_store_contact: {
            name: "",
            email_address: ""
          },
          billing_program_type_id: null,
          scan_collection_program_id: null,
          ad_break_day_id: null,
          tpr_break_day_id: null,
          ad_length: null,
          awg_center_deliver_day_ids: [],
          arg_vmc_program: false,
          rebate: {
            paying_option_id: "",
            street: "",
            city: "",
            state: "",
            zip_code: ""
          },
          hosting_file_participation_id: null,
          hosting_file_program_id: null,
          hosting_file_type_id: null,
          it_contact: {
            name: "",
            email_address: "",
            phone_number: ""
          },
          pos_contact: {
            pos_provider_id: "",
            name: "",
            email: "",
            phone_number: "",
            equipment: "",
            pos_brand_id: ""
          },
          closed_on_sunday: false,
          open_24_hours: false,
          loyalty_digital_coupon_customer_id: "",
          advertising_service_id: "",
          other_sponsored_programs: []
      },
      paymentTypes: [],
      billingTypes: [],
      activeStoreIdList: [],
      checkId: "",
      scanOnlyId: "",
      scanAndBillbackId: "",
      errorMessage: ""
    }
  },
  async created() {
    try {
          this.paymentTypes = (await kvApi.keyValues.getList("PAYMENT_OPTION", 100, 0)).data;
          this.checkId = this.paymentTypes.find(o => o.constant === 'CHECK').id
          this.billingTypes = (await kvApi.keyValues.getList("BILLING_PROGRAM_TYPE", 100, 0)).data;
          this.scanOnlyId = this.billingTypes.find(o => o.constant === 'SCAN_ONLY').id
          this.scanAndBillbackId = this.billingTypes.find(o => o.constant === 'SCAN_AND_BILLBACK').id
          this.getActiveStoreList()
        } catch (err) {
          this.handleError(err);
        }
  },
  computed: {
    fields() {
      const base_fields = [
        // PAGE 1 ~ Store Information
        { label:"Store Start Date", required: true, value:"start_date", type:"date", page: 1, tooltip: 'Store Start Date must be SUNDAY. Choose the Sunday prior to the first Ad Date.'},
        { label:"Store Name", required: true, value:"name",  type:"string", page: 1, tooltip: 'Enter AWG Store Name or Office Name' },
        { label:"AWG Store Number", value:"store_number", required: true,  type:"string", page: 1, tooltip: 'Enter AWG Wholesaler Store Number' },
        { label:"Owner", value:"owner_id", required: true, type:"select", page: 1, tooltip: 'Owner Group must exist before a Store can be created.  Contact Sam to create new Owner before proceeding'},
        { label:"Group Manager", value:"group_manager_id", type:"select", page: 1 },
        { label:"AWG Division", value:"division_id",  type:"select", page: 1, tooltip: 'Division must already exist.  Contact Sam to create a new Division before proceeding' },
        { label:"Store Format", value:"store_format_id", required: true, type:"select", page: 1 },
        { label:"Ad Group", value:"ad_group_id", required: true, type:"select", page: 1, tooltip: 'AD GROUP must already exist.  Contact Sam to create a new AD GROUP before proceeding' },
        { label:"Weekly Store Sales", value:"weekly_sales", required: true, type:"string", page: 1 },
        { label:"Store Square Footage", value:"square_footage", required: true, type:"string", page: 1, cols: 4 },
        { label:"Store Address", value:"store_address",  type:"section", page: 1, required: true, cols: 12, sectionFields: [
          { label:"Street", value:"street", required: true, type:"string", cols: 3, page: 1 },
          { label:"City", value:"city", required: true, type:"string", page: 1 },
          { label:"State", value:"state", required: true, type:"select", cols: 3, page: 1 },
          { label:"Zip Code", value:"zip_code", required: true, type:"number", page: 1 },
          { label:"Phone Number", value:"phone_number", required: true, type:"string", cols: 3, page: 1 },
        ]},
        {label:"Key Store Contact", value:"key_store_contact",  type:"section", page: 1, cols: 8, sectionFields: [
          { label:"Key Contact Name (First and Last)", value:"name", required: true, type:"string", cols: 6, page: 1 },
          { label:"Key Contact Email", value:"email_address", required: true, type:"string", cols: 6, page: 1 },
        ]},
        // PAGE 2 ~ Store Information (cont.)
        { label:"Billing Program Type", value:"billing_program_type_id", required: true, type:"select", page: 2 },
        { label:"Scan Collection Program", value:"scan_collection_program_id", required: true, type:"select", page: 2, tenant_limit: ['alliance-retail-group'],
          tooltip: "Select N/A if Billing Program is not 'Scan Only' or 'Scan and Billback'"
         },
        { label:"Ad Break Day", value:"ad_break_day_id", required: true, type:"select", page: 2 },
        { label:"TPR Break Day", value:"tpr_break_day_id", required: true, type:"select", page: 2 },
        { label:"Ad Length", value:"ad_length", required: true, type:"select", page: 2 },
        { label:"AWG Center Store Delivery Days", value:"awg_center_deliver_day_ids", required: true, type:"array", page: 2 },
        { label:"ARG VMC Program", value:"arg_vmc_program", type:"boolean", cols: 3, page: 2,
          tooltip: "Check if store will participate in the ARG VMC Program"
        },
        { label:"Closed On Sunday", value:"closed_on_sunday",  type:"boolean", cols: 3, page: 2 },
        { label:"Open 24 Hours", value:"open_24_hours",  type:"boolean", cols: 3, page: 2 },
        { label:"Rebate", value:"rebate", type:"section", page: 2, cols: 12, sectionFields: [
          { label:"Paying Option", value:"paying_option_id", required: true, type:"select", cols: 3, page: 2 },
          { label:"Street", value:"street",  type:"string", required: this.params.rebate.paying_option_id === this.checkId, cols: 3, page: 2 },
          { label:"City", value:"city",  type:"string", required: this.params.rebate.paying_option_id === this.checkId, page: 2 },
          { label:"State", value:"state",  type:"select", required: this.params.rebate.paying_option_id === this.checkId, cols: 3, page: 2 },
          { label:"Zip Code", value:"zip_code",  type:"number", required: this.params.rebate.paying_option_id === this.checkId, page: 2 },
        ]},
        // PAGE 3 ~ Technology
        { label:"ARG Hosting File Participation", value:"hosting_file_participation_id", required: true, type:"select", page: 3,
          tooltip: "If participating in ARG Hosting, select appropriate option"
        },
        { label:"Hosting File Type", value:"hosting_file_type_id", required: !['null', null].includes(this.params.hosting_file_participation_id), type:"select", page: 3 },
        { label:"Hosting File Program (External)", value:"hosting_file_program_id", required: ['null', null].includes(this.params.hosting_file_participation_id), type:"select", page: 3 },
        { label:"IT Contact", value:"it_contact",  type:"section", page: 3, cols: 12, sectionFields: [
          { label:"Name (First and Last)", value:"name", required: true, type:"string", cols: 4, page: 3 },
          { label:"Email Address", value:"email_address", required: true, type:"string", cols: 3, page: 3 },
          { label:"Phone Number", value:"phone_number", required: true, type:"string", cols: 3, page: 3 },
        ]},
        {label:"POS Information", value:"pos_contact",  type:"section", page: 3, cols: 12, sectionFields: [
          { label:"POS Provider", value:"pos_provider_id", required: [this.scanOnlyId, this.scanAndBillbackId].includes(this.params.billing_program_type_id),  type:"select", cols: 4, page: 3 },
          { label:"POS Equipment Brand", value:"pos_brand_id", required: [this.scanOnlyId, this.scanAndBillbackId].includes(this.params.billing_program_type_id),  type:"select", cols: 4, page: 3 },
          { label:"POS Software Provider Equipment", value:"equipment", required: [this.scanOnlyId, this.scanAndBillbackId].includes(this.params.billing_program_type_id), type:"string", page: 3, cols: 4,
            tooltip: "Identify the Model, Software version, and BackOffice software." },
          { label:"POS Contact Name (First and Last)", value:"name", required: [this.scanOnlyId, this.scanAndBillbackId].includes(this.params.billing_program_type_id), type:"string", cols: 4, page: 3 },
          { label:"Email", value:"email", required: [this.scanOnlyId, this.scanAndBillbackId].includes(this.params.billing_program_type_id), type:"string", cols: 3, page: 3 },
          { label:"Phone Number", value:"phone_number", required: [this.scanOnlyId, this.scanAndBillbackId].includes(this.params.billing_program_type_id), type:"string", cols: 3, page: 3 },
        ]},
        // Page 4 ~ Marketing/Advertising
        { label:"Loyalty Digital Coupon Customer", value:"loyalty_digital_coupon_customer_id", required: true, cols: 6, type:"select", page: 4 },
        { label:"Advertising Services", value:"advertising_service_id", required: true, type:"select", page: 4 },
        { label:"Other Sponsored Programs", value:"other_sponsored_programs", type:"array", page: 4 },
      ]

      let tenant_fields = base_fields.filter(field => !field.tenant_limit || field.tenant_limit.includes(this.$auth.tenant)).map(field => {
        if (field.type === 'section' && field.sectionFields) {
          return {
            ...field,
            sectionFields: field.sectionFields.filter(secField => !secField.tenant_limit || secField.tenant_limit.includes(this.$auth.tenant))
          }
        }
        return field
      })

      return tenant_fields
    },
    
  groupFields() {
  let groupedFields = {};

  this.fields.forEach(field => {
    if (!groupedFields[field.page]) {
      groupedFields[field.page] = [];
    }

    if (field.type === "section") {
      groupedFields[field.page].push([field]);
    } else {
      let lastGroup = groupedFields[field.page][groupedFields[field.page].length - 1];
      
      if (!lastGroup || lastGroup.length >= 3 || lastGroup[0].type === "section") {
        groupedFields[field.page].push([field]);
      } else {
        lastGroup.push(field);
      }
    }
  });
  return groupedFields;
},

pageIsValid() {
  return this.validatePageValues(this.groupFields[this.view])
}
  },
  methods: {
    updateParams(payload) { 
      this.params = payload
    },

    async getActiveStoreList() {
      const res = await Party.getStoresByTenant()
      const activeStoreList = res.data.filter(store => !store?.end_date || new Date() < new Date(store.end_date))
      this.activeStoreIdList = activeStoreList.map(store => store.wholesaler_store_number)
    },
    
   flattenObject(obj, parentKey = '', result = {}) {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            let newKey = parentKey ? `${parentKey}_${key}` : key;
            if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                this.flattenObject(obj[key], newKey, result);
            } else {
                result[newKey] = Array.isArray(obj[key]) ? obj[key].join('; ') : obj[key];
            }
        }
    }
    return result;
},
convertToCSV(objArray) {
    const flatObj = this.flattenObject(objArray);
    const headers = Object.keys(flatObj).join(',');
    const values = Object.values(flatObj).map(val => `"${val}"`).join(',');

    const csvString = `${headers}\n${values}`;
    this.uploadCSV(csvString)
},

async uploadCSV(csvString) {
    try {
        let blob = new Blob([csvString], { type: "text/csv" });

        let file = new File([blob], "data.csv", { type: "text/csv" });
        let fileName = `${this.params.name.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_]/g, "")}.csv`

        await Party.uploadStoreCSV(file, fileName).then(() => {
          this.emitAlert(true, 'success','Store information submitted.')
          this.view = 1
          this.params = {}
        })
    } catch (error) {
      this.handleError(error);
    }
},

validatePageValues(page) {
  const arr = []
  page.map(group => group.map(field => {
    if (field.sectionFields?.length > 0) {
      field.sectionFields.map(subfield => {
        arr.push(!(subfield.required && (this.params[`${field.value}`][`${subfield.value}`] === null || this.params[`${field.value}`][`${subfield.value}`] === '' || this.params[`${field.value}`][`${subfield.value}`]?.length === 0)))
      })
    } else {
      arr.push(!(field.required && (this.params[`${field.value}`] === null || this.params[`${field.value}`] === '' || this.params[`${field.value}`]?.length === 0)))
    }
  }))
  return !arr.includes(false) && this.errorMessage === null
},
forward() {
  this.view++
},
back() {
  this.view--
},
close() {
  this.view = 1
  this.$emit('close')
},
createStore() {
  this.params.tenant = this.tenant
  this.params.user_email = this.user.email
  this.convertToCSV(this.params)
  this.$emit('close')
},
updateErrorMessage(string) {
  this.errorMessage = string
}
  }
}
</script>
<style>
.v-stepper__content {
  height: 580px !important
}
</style>